import { useEffect, useRef } from "react";
import { clearStorage, getStorage } from "../utils/storage";

const INACTIVITY_LIMIT = 60 * 60 * 1000; // 1 hour of no activity

const InactivityTracker = () => {
  const timerRef = useRef(null);

  const logout = async () => {
    const user = await getStorage();
    await clearStorage();
    window.location.href =
      user?.role === "donor" ? "/login" : "/admin-login";
  };

  const resetTimer = () => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(logout, INACTIVITY_LIMIT);
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "scroll", "click", "touchstart"];

    events.forEach((e) => window.addEventListener(e, resetTimer));
    resetTimer(); // start the timer immediately

    return () => {
      clearTimeout(timerRef.current);
      events.forEach((e) => window.removeEventListener(e, resetTimer));
    };
// eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default InactivityTracker;
